import L10n from "../common/L10n";
import store from '../store/Store';
import CardDataStore from '../store/CardDataStore';
import { ICard } from '../interface/ICardList';
import dedent from "../libs/dedent";

export default class Nodata {
    constructor() {
        store.CardDataStore.updateEvents.on( this.update.bind(this) );
    }

    private update(_src: CardDataStore, _data: ICard[]){
        const historyList: HTMLElement|null = document.querySelector('.history-list');
        if( _data.length<1 && historyList){
            historyList.innerHTML = dedent`
            <li class="history-article history-nodata">
                <svg xmlns="http://www.w3.org/2000/svg" width="81" height="83" viewBox="0 0 81 83" class="icon-nodata">
                    <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                        <ellipse cx="39.676" cy="40.266" fill="#666" fill-opacity=".03" stroke="#3E3E3E" stroke-opacity=".15" rx="39.676" ry="40.266"/>
                        <g fill="#A7A7A7" opacity=".5" transform="translate(26.169 29.7)">
                            <path d="M.702 2.504c0-3.339 5.063-3.339 5.063 0 0 3.342-5.063 3.342-5.063 0zM22.828 2.504c0-3.339 5.062-3.339 5.062 0 0 3.342-5.062 3.342-5.062 0z"/>
                            <rect width="25.205" height="3.284" x="1" y="19" rx="1.642"/>
                        </g>
                    </g>
                </svg>
                <div class="">${L10n.noresult}</div>
            </li>`;
        }
    }

} // end of class
